import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { GbTermsAndConditionsComponent } from 'libs/gb-front/account/ui/src/lib/gb-terms-and-conditions/gb-terms-and-conditions.component'

//TODO IMPORT GUARDS

// import { GbLoginComponent } from './components/auth/gb-login/gb-login.component'
// import { GbItemListComponent } from './components/item/gb-item-list/gb-item-list.component'
// import { GbNotFoundComponent } from './components/not-found/gb-not-found/gb-not-found.component'

export const routes: Routes = [
  { path: '', redirectTo: '/not-found', pathMatch: 'full' },
  {
    path: 'not-found',
    loadChildren: () =>
      import('libs/gb-front/not-found/feature/src/lib/gb-front-not-found-feature.module').then(
        (m) => m.GbFrontNotFoundFeatureModule,
      ),
  },
  {
    path: 'under-scheduled-maintenance',
    loadChildren: () =>
      import('libs/shared/maintenance/src/lib/shared-maintenance.module').then((m) => m.SharedMaintenanceModule),
  },
  {
    path: 's',
    loadChildren: () =>
      import('libs/gb-front/short-url/feature/src/lib/gb-front-short-url-feature.module').then(
        (m) => m.GbFrontShortUrlFeatureModule,
      ),
  },
  {
    path: 'v',
    loadChildren: () =>
      import('libs/gb-front/voucher/feature/src/lib/gb-front-voucher-feature.module').then(
        (m) => m.GbFrontVoucherFeatureModule,
      ),
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () => GbTermsAndConditionsComponent,
  },
  {
    path: ':urlName',
    loadChildren: () =>
      import('libs/gb-front/auction/feature/src/lib/gb-front-auction-feature.module').then(
        (m) => m.GbFrontAuctionFeatureModule,
      ),
  },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
